import React, { useEffect, useState } from 'react';
import { PagingQuery } from 'tea-component';
import { SortByItemType } from '@/pages/intelligence/components/TableComponents/components/SortBy';
import TopchartTable from '@/pages/intelligence/components/TableComponents/TopchartTable';
import { CompanyCountriesShareCloums } from '@/pages/intelligence/pages/TopCharts/_config/TableCloums/CompanyCountriesShareCloums';
import { MetricsTableCloums } from '@/pages/intelligence/pages/TopCharts/_config/TableCloums/MetricsTableCloums';
import { getMetricValueOfCvmTrendCountry } from '../_utils';
import useIntlExtend from '@/pages/intelligence/hooks/useIntlExtend';

const TrendsCard = (props: any) => {
  const {
    tableData = [],
    pageId,
    dateType,
    tableTotal,
    columnsList,
    tableLoading,
    onTableSortChage,
    onTablePagingChange,
    segementType,
    entityType
  } = props;

  const { formatMessage } = useIntlExtend();
  const [sortTableData, setSortTableData] = useState(tableData);
  const [pageSortAttr, setPageSortAttr] = useState({
    currentSortValue: 'desc',
    currentSortMetric: segementType,
    currentRatioType: 0,
  });
  const defaultPageSize = 5;
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(defaultPageSize);
  const {
    // tablePageIndex,
    // tablePageSize,
    currentSortValue,
    currentSortMetric,
    currentRatioType,
    // currentOrderSource,
  } = pageSortAttr || {};

  useEffect(() => {
    setSortTableData(tableData);
  }, [JSON.stringify(tableData)]);

  const onSortChage = (e: SortByItemType) => {
    setPageSortAttr({
      currentSortValue: e.sortVal,
      currentSortMetric: e.sortMetric,
      currentRatioType: e?.ratioType || 0,
    });
    onTableSortChage(e);
    //将页码重置,与接口一至
    setPageIndex(1);
    setPageSize(defaultPageSize);
  };

  const getNoDropdown = (value: string, segementType: string) => {
    if (segementType === 'digitalRevenue') {
      return value === 'units';
    } else if (segementType === 'units') {
      return value === 'digitalRevenue';
    }
    return false;
  };

  const getMetricCloums = () => {
    const metricCloums: any[] = [];
    columnsList?.forEach((t: any) => {
      metricCloums.push(
        MetricsTableCloums({
          isNoDropdown: getNoDropdown(t.value, segementType),
          onlySimpleSort: false,
          renderType: t?.renderType,
          width: t?.width,
          width_cn: t?.width_cn,
          dataSource: t?.dataSource, //source === 'ogdb' ? 'databarin' : source,
          title: t?.text,
          textContent: t?.info,
          tipText: t?.iconInfo,
          key: `${t?.value}`,
          sortMetric: t?.value,
          currentSortValue: currentSortValue,
          currentSortKey: `${currentSortMetric}_${currentRatioType}`,
          onSortChage: onSortChage,
          dateType: dateType,
          pageId: pageId,
          getMetricValueOfCvm: getMetricValueOfCvmTrendCountry,
          growthValueType: 'percentValue',
          formatMessage,
          entityType
        }),
      );
    });
    return metricCloums;
  };

  const onPagingChange = (e: PagingQuery) => {
    setPageIndex(e.pageIndex || 1);
    setPageSize(e.pageSize || defaultPageSize);
    onTablePagingChange(e);
  };

  return (
    <>
      <TopchartTable
        recordKey="name"
        loading={tableLoading}
        records={sortTableData}
        tableTotal={tableTotal}
        pageIndex={pageIndex}
        pageSize={pageSize}
        onPagingChange={onPagingChange}
        pageSizeOptions={[5, 10, 15]}
        className="dbi-mobileGames-details-table"
        columns={[
          CompanyCountriesShareCloums({
            countriesShareType: 'market',
            firstLineName: 'dbi_detail_table_total'
          }),
          ...getMetricCloums(),
        ]}
      />
    </>
  );
};

export default TrendsCard;
